const map = {
	"./favicon.svg": [
		70011,
		[
			11
		]
	],
	"./logo.svg": [
		86776,
		[
			6776
		]
	],
	"./sidebar.svg": [
		25027,
		[
			5027
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42515;
module.exports = webpackAsyncContext;